import { useLogout } from "~/screens/Auth/hooks/useLogout";
import { icons } from "~/ui";

export const AdminMobileNavFooter = () => {
  const { mutate: logout } = useLogout();

  return (
    <div className="border-blueGrey border-t p-4">
      <button
        onClick={() => logout()}
        className="text-soft-gray hover:bg-lavender-mist hover:text-indigo flex w-full items-center gap-3 rounded-lg px-4 py-3 text-left text-base font-medium transition-colors"
      >
        <icons.outline.ArrowLeftEndOnRectangleIcon className="size-5 shrink-0" />
        Logout
      </button>
    </div>
  );
};
